// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".service-details__aside[data-v-2aa0a2e3]{width:258px!important;background:#f0f0f0;border:1px solid #d3d7d8;border-right:none;padding:33px 28px 0}.service-details__main[data-v-2aa0a2e3]{background-color:#fff;border:1px solid #d3d7d8;padding:33px 28px 40px;width:100%}.service-details__main .service-details-section[data-v-2aa0a2e3]:not(:last-child){margin-bottom:50px}", ""]);
// Exports
module.exports = exports;
